const LONDON_KEY = /^\d{4}-\d{2}-\d{2}$/;

const londonFormatter = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/London",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/**
 * The only Daily identity: the Europe/London calendar date of `instant` as a
 * strict YYYY-MM-DD key. The device-local calendar, fixed UTC offsets and
 * toISOString() truncation never decide the Daily. Fails closed when the zone
 * or parts cannot be resolved.
 */
export function londonDateKey(instant: Date = new Date()): string {
  const parts = londonFormatter.formatToParts(instant);
  const year = parts.find((part) => part.type === "year")?.value ?? "";
  const month = parts.find((part) => part.type === "month")?.value ?? "";
  const day = parts.find((part) => part.type === "day")?.value ?? "";
  const key = `${year}-${month}-${day}`;
  if (!LONDON_KEY.test(key)) throw new Error("Unable to resolve the Europe/London date");
  return key;
}

/** Whole London days from `fromKey` to `toKey`; NaN for malformed keys. */
export function londonDayDistance(fromKey: string, toKey: string): number {
  if (!isGregorianKey(fromKey) || !isGregorianKey(toKey)) return Number.NaN;
  return Math.round((Date.parse(`${toKey}T00:00:00Z`) - Date.parse(`${fromKey}T00:00:00Z`)) / 86_400_000);
}

/** Strict YYYY-MM-DD that names a real Gregorian calendar date. */
export function isGregorianKey(key: string): boolean {
  if (!LONDON_KEY.test(key)) return false;
  const date = new Date(`${key}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === key;
}
